export enum RESPONSE {
  SUCESSO = "SUCESSO",
  SUCESSO_LOGIN = "SUCESSO_LOGIN",
  SUCESSO_NADA_ENCONTRADO = "SUCESSO_NADA_ENCONTRADO",
  SUCESSO_PERSISTENCIA = "SUCESSO_PERSISTENCIA",
  SUCESSO_CONSULTA = "SUCESSO_CONSULTA",
  SUCESSO_REMOCAO = "SUCESSO_REMOCAO",
  ERRO = "ERRO",
  ERRO_REMOCAO = "ERRO_REMOCAO",
  ERRO_CONSULTA = "ERRO_CONSULTA",
  ERRO_PERSISTENCIA = "ERRO_PERSISTENCIA",
  EXIGE_CONFIRMACAO = "EXIGE_CONFIRMACAO",
  ERRO_LOGIN = "ERRO_LOGIN",
  SUCESSO_SAIR = "SUCESSO_SAIR",
  NAO_AUTORIZADO = "NAO_AUTORIZADO",
  SUCESSO_OBTER_ARQUIVO = "SUCESSO_OBTER_ARQUIVO",
  PARAMETRO = "PARAMETRO",
}
